import React from "react";
import {makeRoutes, publicRoutes, route} from "./utils";
import Channel from "../../layouts/Channel";
import Dashboard from "../../layouts/Dashboard";
import AuthorizationCode from "../../layouts/Channel/Authorization/Code";
import LoginChannel from "../../views/ChannelLogin/Login";

const allowed = publicRoutes.concat([
  route(`/rau`, props => <LoginChannel rau={true} {...props}/>),
  route(`/panel/login-code`, AuthorizationCode),
  route(`/panel/:provider/login-code`, props => <AuthorizationCode {...props} provider={props.match.params.provider} />),
  route("/panel", Dashboard),
  route("/", Channel)
]);

export default makeRoutes(allowed, [], route("/", Channel));